import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import { toQueryParameters, toSearchString } from 'tradera-utils/url';
import ALink from 'tradera-components/alink/alink';
import SearchIcon from '@tradera/blueprint/theme/icons2/search.svg?jsx';

const ProfileHeaderNav = ({ hasShop }) => {
    const location = useLocation();
    const { t } = useTranslator();
    const history = useHistory();
    const { q: searchTerm = '' } = toQueryParameters(location.search);
    const [searchString, setSearchString] = useState(searchTerm);

    useEffect(() => {
        setSearchString(searchTerm);
    }, [searchTerm]);

    const { memberId, aliasSlug, profilePageType } = useParams();
    const { toLocalizedUrl } = useUrlLocalizer();

    const handleProfileSearch = query => {
        const q = query.trim();
        history.push({
            pathname: location.pathname,
            search: toSearchString(q ? { q } : null)
        });
    };

    return (
        <div className="container border-bottom">
            <div className="row d-flex flex-wrap">
                <div className="col mb-2 mb-md-0">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <ALink
                                useLink={true}
                                className={`nav-link ${
                                    profilePageType === 'items' ? 'active' : ''
                                }`}
                                href={toLocalizedUrl(
                                    `/profile/items/${memberId}/${aliasSlug}`
                                )}>
                                {t('profileMenu_items')}
                            </ALink>
                        </li>
                        <li className="nav-item">
                            <ALink
                                useLink={true}
                                className={`nav-link ${
                                    profilePageType === 'feedback'
                                        ? 'active'
                                        : ''
                                }`}
                                href={toLocalizedUrl(
                                    `/profile/feedback/${memberId}/${aliasSlug}`
                                )}>
                                {t('profileMenu_ratings')}
                            </ALink>
                        </li>
                        {hasShop && (
                            <>
                                <li className="nav-item">
                                    <ALink
                                        useLink={true}
                                        className={`nav-link ${
                                            profilePageType === 'information'
                                                ? 'active'
                                                : ''
                                        }`}
                                        href={toLocalizedUrl(
                                            `/profile/information/${memberId}/${aliasSlug}`
                                        )}>
                                        {t('profileMenu_info')}
                                    </ALink>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
                <div className="col-12 col-md-6 mb-2 mb-md-0 d-flex align-items-center">
                    <div className="form-control-with-icon w-100">
                        <form
                            onSubmit={e => {
                                e.preventDefault();
                                handleProfileSearch(searchString);
                            }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('profileMenu_search')}
                                value={searchString}
                                onChange={e => setSearchString(e.target.value)}
                            />
                        </form>
                        <SearchIcon className="icon icon-dark mr-2" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export { ProfileHeaderNav };
